import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeHigh } from "@fortawesome/free-solid-svg-icons";
import { useContext } from "react";
import { ActividadContext } from "./ActividadesUtils/ActWrapper";
import CerrarActButton from "../ActividadesUtils/CerrarActButton";
import ImagenValidadaComparador from "./ActividadesUtils/RecursosValidados/ImagenValidadaComparador";

const MemoramaForPDFs = ({ data, evaluable, instrucciones }) => {
  const activityContext = useContext(ActividadContext);

  const handleCerrarAct = () => {
    activityContext.postCalificacionActividad(null);
  };

  return (
    <div className="my-5 w-full">
      {instrucciones && <div className="max-w-activity act-instructions mb-6">{instrucciones}</div>}
      <section className="memory-game relative  max-w-activity">
        {data.map((item, index) => (
          <div
            className={`relative memory-card pointer-events-none`}
            key={index}
          >
            {!evaluable ? (
              <div className="absolute top-1 left-1 z-10 !bg-[#3ea34d] font-bold text-sm !w-7 !h-7 !text-white flex justify-center align-center !rounded-full back-face !p-0 items-center">
                {item.orden}
              </div>
            ) : (
              ""
            )}
            {/* back-face (sin rotar): front-face lleva rotateY(180deg) y aquí la
                carta nunca se voltea, así que la imagen saldría en espejo.
                Se le quita el padding y se usa cover para que todas midan igual. */}
            {item.imagen ? (
              <ImagenValidadaComparador
                className="back-face !object-cover !p-0 !bg-white border border-[#dcdcdc] overflow-hidden"
                src={
                  typeof item.imagen !== "string"
                    ? URL.createObjectURL(item.imagen)
                    : item.imagen
                }
              />
            ) : (
              ""
            )}
            {item.texto ? (
              <div className="back-face !bg-white border border-[#dcdcdc] flex items-center justify-center text-sm md:text-xl text-nimbus text-center p-2 md:p-4">
                {item.texto}
              </div>
            ) : (
              ""
            )}
            {/* El ícono va DENTRO de un contenedor, no con la clase encima del
                <svg>: FontAwesome inyecta `svg:not(:host).svg-inline--fa
                {overflow:visible;box-sizing:content-box}`, que por especificidad
                le gana a .back-face y hacía que el ícono se saliera de la carta. */}
            {item.audio ? (
              <div className="back-face !bg-white border border-[#dcdcdc] flex items-center justify-center overflow-hidden">
                <FontAwesomeIcon
                  className="w-1/2 h-1/2"
                  color={"#1c7ccc"}
                  icon={faVolumeHigh}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        ))}
      </section>
      <CerrarActButton onClick={handleCerrarAct} />
    </div>
  );
};

MemoramaForPDFs.defaultProps = {
  evaluable: true,
  data: [],
};

export default MemoramaForPDFs;
